module.exports = __webpack_public_path__ + "img/ezgif-7-e1ee2a0494.bcd9042b.gif";